
import { defineComponent } from "vue";
import axios from "axios";
import meetlookup from "../MeetLookup";
import { ClubAthlete, Club, RelayEvent } from "@/types/Club";
import { Athlete } from "@/types/Athlete";
import AthletesTable from "@/components/AthletesTable.vue";
import RelayTable from "@/components/RelayTable.vue";
import PullRefresh from "pull-refresh-vue3";

export default defineComponent({
  mixins: [meetlookup],
  components: {
    AthletesTable,
    RelayTable,
    PullRefresh,
  },
  props: {
    athleteid: {
      type: String,
      required: false,
    },
    meetid: {
      type: String,
      required: true,
    },
    clubid: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      club: (null as unknown) as Club,
      athletesFocus: [] as Array<Athlete>,
      athletesFemale: [] as Array<Athlete>,
      athletesMale: [] as Array<Athlete>,
      relayEvents: [] as Array<RelayEvent>,
      isLoading: false,
    };
  },
  methods: {
    fetchMulti() {
      this.fetch(
        this.club.athletes.filter((athlete) => athlete.id == this.athleteid),
        this.athletesFocus
      );

      this.fetch(
        this.club.athletes.filter((athlete) => athlete.gender == "1"),
        this.athletesMale
      );

      this.fetch(
        this.club.athletes.filter((athlete) => athlete.gender == "2"),
        this.athletesFemale
      );
    },
    openTab(evt, tabName) {
      // https://www.w3schools.com/howto/howto_js_tabs.asp
      // Declare all variables
      var i, tabcontent, tablinks;

      this.$store.dispatch("setClubTab", tabName);

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      let element = document.getElementById(tabName);

      if (element) {
        element.style.display = "block";
        if (evt) {
          evt.currentTarget.className += " active";
        } else {
          let maleButton = document.getElementById(tabName.toLowerCase() + "-button");
          if (maleButton) {
            maleButton.className += " active";
          }
        }
      }
    },

    fetch(clubAthletes: Array<ClubAthlete>, athletes) {
      // TODO: Fix DataType
      for (let idx = 0; idx < clubAthletes.length; idx++) {
        axios
          .get(
            "https://live.swimrankings.net/meets/" +
              this.meetid +
              "/athletes/" +
              clubAthletes[idx].id +
              ".json",
            { params: { t: new Date().getTime() } }
          )
          .then((response) => response.data as Athlete)
          .then((athlete) => {
            for (let idx = 0; idx < athlete.results.length; idx++) {
              if (
                this.get_seconds_from_swimrankingstime(athlete.results[idx].swimtime) <
                this.get_seconds_from_swimrankingstime(athlete.results[idx].entrytime)
              ) {
                athlete.results[idx].isPb = true;
              } else {
                athlete.results[idx].isPb = false;
              }
              var performance =
                this.get_seconds_from_swimrankingstime(athlete.results[idx].entrytime) /
                this.get_seconds_from_swimrankingstime(athlete.results[idx].swimtime);
              athlete.results[idx].performance = performance * performance;
              athlete.results[idx].eventnr = this.get_event_number_from_event_id(
                athlete.results[idx].eventid
              );
            }
            athlete.results.sort(function (result_a, result_b) {
              // Sort result events
              if (result_a.eventnr && result_b.eventnr) {
                return (
                  result_a.eventnr - result_b.eventnr ||
                  parseInt(result_a.eventid) - parseInt(result_b.eventid)
                );
              }
              return 0;
            });

            for (let idx = 0; idx < athlete.entries.length; idx++) {
              athlete.entries[idx].eventnr = this.get_event_number_from_event_id(
                athlete.entries[idx].eventid
              );
            }
            athlete.entries.sort(function (entry_a, entry_b) {
              // Sort entry events
              if (entry_a.eventnr && entry_b.eventnr) {
                return (
                  entry_a.eventnr - entry_b.eventnr ||
                  parseInt(entry_a.eventid) - parseInt(entry_b.eventid)
                );
              }
              return 0;
            });
            athlete.lastname = this.get_last_name_from_athlete_id(athlete.id);
            athletes.push(athlete);

            athletes.sort(function (athlete_a, athlete_b) {
              // Sort gender, name, age
              var sort_name = 1;
              if (athlete_b.lastname > athlete_a.lastname) {
                sort_name = -1;
              }
              return (
                parseInt(athlete_a.gender) - parseInt(athlete_b.gender) ||
                sort_name ||
                athlete_b.age - athlete_a.age
              );
            });
          });
      }
    },
    onRefresh() {
      this.$gtag.event("live", {
        event_category: "live_pageload",
        event_label: "live_club",
      });
      this.isLoading = true;
      this.athletesFocus = [];
      this.athletesMale = [];
      this.athletesFemale = [];
      this.update_meet();
      this.fetchMulti();
      this.isLoading = false;
    },
  },
  mounted() {
    this.$gtag.event("live", {
      event_category: "live_pageload",
      event_label: "live_club",
    });
    localStorage.selectedClubId = this.clubid;
    axios
      .get<Club>(
        "https://live.swimrankings.net/meets/" +
          this.meetid +
          "/clubs/" +
          this.clubid +
          ".json",
        { params: { t: new Date().getTime() } }
      )
      .then((response) => response.data)
      .then((club) => {
        this.relayEvents = [];
        for (let ii = 0; ii < club.results.length; ii++) {
          let found = false;
          club.results[ii].isPb = false;
          if (
            this.get_seconds_from_swimrankingstime(club.results[ii].swimtime) <
            this.get_seconds_from_swimrankingstime(club.results[ii].entrytime)
          ) {
            club.results[ii].isPb = true;
          }
          for (let kk = 0; kk < this.relayEvents.length; kk++) {
            if (this.relayEvents[kk].eventid == club.results[ii].eventid) {
              this.relayEvents[kk].results.push(club.results[ii]);
              found = true;
              break;
            }
          }
          if (!found) {
            let relayEvent: RelayEvent = {
              eventid: club.results[ii].eventid,
              results: [club.results[ii]],
              entries: [],
            };
            this.relayEvents.push(relayEvent);
          }
        }
        for (let ii = 0; ii < club.entries.length; ii++) {
          let found = false;
          for (let kk = 0; kk < this.relayEvents.length; kk++) {
            if (this.relayEvents[kk].eventid == club.entries[ii].eventid) {
              this.relayEvents[kk].entries.push(club.entries[ii]);
              found = true;
              break;
            }
          }
          if (!found) {
            let relayEvent: RelayEvent = {
              eventid: club.entries[ii].eventid,
              results: [],
              entries: [club.entries[ii]],
            };
            this.relayEvents.push(relayEvent);
          }
        }

        this.club = club;
        this.fetchMulti();
      });
  },
  computed: {},
  updated() {
    if (this.clubTab) {
      this.openTab(null, this.clubTab);
    } else {
      this.openTab(null, "Male");
    }
  },
});
